import React from "react";
import { Box, TextField, Button, IconButton, Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  SearchOutlined,
  ChatBubbleOutlineOutlined,
  NotificationsOutlined,
  SettingsOutlined,
} from "@mui/icons-material";

import chatbotIcon from '../../assets/icons/chatbot.png';

const Header = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 16px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)", // Hafif gölge
        height: "56px", // Görselle uyumlu yükseklik
      }}
    >
      {/* Search Bar */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#F4F5F7",
          borderRadius: "20px",
          padding: "6px 12px",
          width: "35%",
          boxShadow: "none",
        }}
      >
        <SearchOutlined sx={{ color: "#6C63FF", fontSize: "20px", marginRight: "8px" }} />
        <TextField
          placeholder="Search for something"
          variant="standard"
          InputProps={{
            disableUnderline: true,
            style: {
              fontSize: "14px",
              width: "100%",
              color: "#333333",
            },
          }}
          sx={{
            "& .MuiInputBase-input": {
              boxShadow: "none",
            },
            "& .MuiInputBase-root": {
              boxShadow: "none",
            },
          }}
        />
      </Box>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Button
          variant="contained"
          onClick={() => navigate("/chatbot")}
          sx={{
            backgroundColor: "#5145A6",
            color: "#FFFFFF",
            textTransform: "none",
            fontSize: "14px",
            borderRadius: "10px",
            height: "32px",
            padding: "0 16px",
            "&:hover": {
              backgroundColor: "#40368C",
            },
          }}
          startIcon={<img src={chatbotIcon} alt="Chatbot Icon" />}
        >
          Chatbot
        </Button>
        <IconButton
          sx={{
            backgroundColor: "#F4F5F7",
            padding: "6px",
            borderRadius: "50%",
          }}
          onClick={() => navigate("/messages")}
        >
          <ChatBubbleOutlineOutlined sx={{ color: "#333333", fontSize: "18px" }} />
        </IconButton>
        <IconButton
          sx={{
            backgroundColor: "#F4F5F7",
            padding: "6px",
            borderRadius: "50%",
          }}
          onClick={() => navigate("/notifications")}
        >
          <NotificationsOutlined sx={{ color: "#333333", fontSize: "18px" }} />
        </IconButton>
        <IconButton
          sx={{
            backgroundColor: "#F4F5F7",
            padding: "6px",
            borderRadius: "50%",
          }}
          onClick={() => navigate("/settings")}
        >
          <SettingsOutlined sx={{ color: "#333333", fontSize: "18px" }} />
        </IconButton>
        <Avatar
          src="https://picsum.photos/200" // Random profil resmi
          alt="Profile"
          sx={{
            width: "32px",
            height: "32px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/profile")}
        />
      </Box>
    </Box>
  );
};

export default Header;
